// noinspection DuplicatedCode

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinMpayrollHO = createAsyncThunk(
  "mpayrollho/getMin",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMinMasterMpayrollHO",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        let newObj = [];
        response.data.data.map((item) =>
          newObj.push({
            value: item.MpayrollID,
            label: item.NamaMpayroll,
          })
        );
        return { data: newObj };
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

export const getMpayrollHO = createAsyncThunk(
  "mpayrollho/get",
  async ({ start, count, search, tipekaryawan }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    formData.append("tipekaryawan", tipekaryawan);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMasterPayrollHO",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

export const insertMpayrollHO = createAsyncThunk(
  "mpayrollho/insert",
  async ({ Nik, UpahPokok, Keahlian, JkIN, JkOUT, THarian, TLemburMakan, Harikeenam  }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("UpahPokok", UpahPokok);
    formData.append("Keahlian", Keahlian);
    formData.append("JkIN", JkIN);
    formData.append("JkOUT", JkOUT);
    formData.append("THarian", THarian);
    formData.append("TLemburMakan", TLemburMakan);
    formData.append("Harikeenam", Harikeenam);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertMasterPayrollHO",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

export const updateMpayrollHO = createAsyncThunk(
  "mpayrollho/update",
  async ({ Nik, UpahPokok, Keahlian, JkIN, JkOUT, THarian, TLemburMakan, Harikeenam  }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("UpahPokok", UpahPokok);
    formData.append("Keahlian", Keahlian);
    formData.append("JkIN", JkIN);
    formData.append("JkOUT", JkOUT);
    formData.append("THarian", THarian);
    formData.append("TLemburMakan", TLemburMakan);
    formData.append("Harikeenam", Harikeenam);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateMasterPayrollHO",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

export const insertUserClient = createAsyncThunk(
  "mpayrollho/update",
  async ({ Nik, Username }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("Username", Username);

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertUserClient",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

const initialState = {
  message: "",
  minData: [],
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
};

export const mpayrollSliceHO = createSlice({
  name: "mpayrollho",
  initialState,
  reducers: {},
  extraReducers: {
    [getMinMpayrollHO.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minData = payload.data;
      return state;
    },
    [getMinMpayrollHO.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload?.message || "Gagal memuat data";
    },
    [getMinMpayrollHO.pending]: (state) => {
      state.isMinFetching = true;
    },

    [getMpayrollHO.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getMpayrollHO.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload?.message || "Gagal memuat data";
    },
    [getMpayrollHO.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertMpayrollHO.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      // window.location.reload(false);
      return state;
    },
    [insertMpayrollHO.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload?.message || "Gagal menyimpan data";
    },
    [insertMpayrollHO.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updateMpayrollHO.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      // window.location.reload(false);
      return state;
    },
    [updateMpayrollHO.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload?.message || "Gagal menyimpan data";
    },
    [updateMpayrollHO.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const mpayrollSelectorHO = (state) => state.mpayrollho;
